<div class="content-area">
  <div class="title-block">
    <div class="title-block__left">
      <h1>Payment Transaction Logs</h1>
    </div>
    <div class="title-block__right">
      <a class="filter-show-hide" (click)="exportData.toggle($event)" pTooltip="Actions" tooltipPosition="top">
        <svg _ngcontent-nwa-c189="" width="21" height="5" viewBox="0 0 21 5" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <circle _ngcontent-nwa-c189="" cx="2.5" cy="2.5" r="2.5" fill="#707070"></circle>
          <circle _ngcontent-nwa-c189="" cx="10.5" cy="2.5" r="2.5" fill="#707070"></circle>
          <circle _ngcontent-nwa-c189="" cx="18.5" cy="2.5" r="2.5" fill="#707070"></circle>
        </svg>
      </a>
      <p-popover appendTo="body" [dismissable]="true" #exportData class="search-filter report-exportData">
        <div class="quick-link-menu">
          <ul>
            <li><a class="invite-schedule" href="javascript:void(0)" (click)="export()">Export</a></li>
          </ul>
        </div>
      </p-popover>

      <a pTooltip="Filters" tooltipPosition="right" class="filter-block filter-show-hide"
        (click)="overlyFilter.toggle($event)">
        <img src="assets/img/filter-ic.svg" width="18" alt="filters" />
      </a>

      <a class="back-btn" routerLink="/admin/reports"><i class="back-new"></i> Back</a>
    </div>
  </div>

  <ul class="report-filters-list">
    <li class="report-filters-list__item" *ngFor="let filter of selectedFilters">
      <a class="report-filters-list__clear" (click)="onClear(filter.prop)" *ngIf="!filter.prop">
        {{ filter.value }}
      </a>
      <span *ngIf="filter.prop">
        {{ filter.value }}
      </span>
      <a class="report-filters-list__link" (click)="onClear(filter.prop)">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.8755 2.17661L2.12453 13.8234" stroke="#3E3E3E" stroke-width="2" />
          <path d="M13.8232 13.8755L2.17637 2.12453" stroke="#3E3E3E" stroke-width="2" />
        </svg>
      </a>
    </li>
  </ul>

  <div class="appointments-scroll reports-detail"
    [ngClass]="selectedFilters?.length == 0 ? 'remove-filter' : 'show-filter'">
    <div class="table-outer-main">
      <p-table #sdl class="table-outer" [value]="items" responsiveLayout="scroll"
        [paginator]="totalRecords > 0 ? true : false" sortMode="single" sortField="PatientName"
        [first]="searchRequest.firstRecordIndex" [sortOrder]="1" [rows]="getTotalRows()" [totalRecords]="totalRecords"
        [lazy]="true" [customSort]="true" (onLazyLoad)="onLazyLoad($event)" [scrollable]="true"
        scrollHeight="calc(100vh - 236px)">
        <ng-template pTemplate="header">
          <tr *ngIf="totalRecords > 0">
            <th class="table-outer__th soid" width="70">S.O. ID</th>
            <th class="table-outer__th Patientid" pSortableColumn="BranchName">Branch<p-sortIcon
                field="BranchName"></p-sortIcon></th>
            <th class="table-outer__th Patientid" pSortableColumn="PatientName">Patient<p-sortIcon
                field="PatientName"></p-sortIcon></th>
            
            <th class="table-outer__th" pSortableColumn="DateOfBirthString">DOB<p-sortIcon
                field="DateOfBirthString"></p-sortIcon></th>
            <th class="table-outer__th" pSortableColumn="AppointmentDateTimeString">
              Appointment Date & Time <p-sortIcon field="AppointmentDateTimeString"></p-sortIcon>
            </th>
            <th class="table-outer__th" pSortableColumn="AppointmentType">Appointment Type <p-sortIcon
                field="AppointmentType"></p-sortIcon></th>
            <th class="table-outer__th" pSortableColumn="ClassificationType">Classification Type <p-sortIcon
                field="ClassificationType"></p-sortIcon></th>
            <th class="table-outer__th" pSortableColumn="PrimaryInsurance">Primary Insurance <p-sortIcon
                field="PrimaryInsurance"></p-sortIcon></th>
            <th class="table-outer__th" pSortableColumn="SecondaryInsurance">Secondary Insurance <p-sortIcon
                field="SecondaryInsurance"></p-sortIcon></th>
            <th class="table-outer__th" pSortableColumn="TertiaryInsurance">Tertiary Insurance <p-sortIcon
                field="TertiaryInsurance"></p-sortIcon></th>
            <th class="table-outer__th" pSortableColumn="TransactionDateTimeString">
              Transaction Date & Time <p-sortIcon field="TransactionDateTimeString"></p-sortIcon>
            </th>
            <th class="table-outer__th" pSortableColumn="TransactionStatus">Transaction Status <p-sortIcon
                field="TransactionStatus"></p-sortIcon></th>
            <th class="table-outer__th" pSortableColumn="AmountCollected">Amount Collected <p-sortIcon
                field="AmountCollected"></p-sortIcon></th>
            <th class="table-outer__th" pSortableColumn="TransactionID">Transaction ID <p-sortIcon
                field="TransactionID"></p-sortIcon></th>
            <th class="table-outer__th" pSortableColumn="CreditCardLast4Digits">Credit Card last 4 Digits <p-sortIcon
                field="CreditCardLast4Digits"></p-sortIcon></th>
            <th class="table-outer__th" style="min-width: 8vw;" pSortableColumn="CardType">Card Type <p-sortIcon
                field="CardType"></p-sortIcon></th>
            <th class="table-outer__th" style="min-width: 18vw;" pSortableColumn="ActionBy">Action By <p-sortIcon
                field="ActionBy"></p-sortIcon></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            
            <td class="table-outer__td soid">
              <span class="table-checkbox">
                {{ item.rcmSalesOrderId }}
              </span>
            </td>
             <td class="table-outer__td soid">
              <span class="table-checkbox">
                {{ item.branchName }}
              </span>
            </td>
            <td class="table-outer__td Patientid">
              <span class="patient">
                {{ item.patientName }}
                <p>{{ item.rcmPatientId }}</p>
              </span>
            </td>
            <td class="table-outer__td">
              {{ item.dateOfBirthString | date: appDateFormat.dateFormat }}
            </td>
            <td class="table-outer__td">
              <span class="date-time">
                {{ item.appointmentDateTimeString | date: appDateFormat.dateFormat }}
                <p>{{ item.appointmentDateTimeString | date: 'shortTime' | lowercase }}</p>
              </span>
            </td>
            <td class="table-outer__td">{{ item.appointmentType }}</td>
            <td class="table-outer__td">{{ item.classificationType }}</td>
            <td class="table-outer__td">{{ item.primaryInsurance }}</td>
            <td class="table-outer__td">{{ item.secondaryInsurance }}</td>
            <td class="table-outer__td">{{ item.tertiaryInsurance }}</td>
            <td class="table-outer__td">
              <span class="date-time">
                {{ item.transactionDateTimeString | date: appDateFormat.dateFormat }}
                <p>{{ item.transactionDateTimeString | date: 'shortTime' | lowercase }}</p>
              </span>
            </td>
            <td class="table-outer__td">{{ item.transactionStatus }}</td>
            <td class="table-outer__td">${{ item.amountCollected }}</td>
            <td class="table-outer__td">{{ item.transactionID }}</td>
            <td class="table-outer__td">{{ item.creditCardLast4Digits }}</td>
            <td class="table-outer__td">{{ item.cardType }}</td>
            <td class="table-outer__td">{{ item.actionBy }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="footer">
          <ng-container *ngIf="!loading && totalRecords <= 0">
            <tr>
              <td class="table-outer__td no-records-found" [attr.colspan]="8">No records found</td>
            </tr>
          </ng-container>
        </ng-template>

        <ng-template pTemplate="paginatorleft" class="table-pagination">
          <span class="table-pagination__records">
            Total Records : &nbsp;<strong> {{ totalRecords }}</strong>
          </span>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="loader-block" *ngIf="loading">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff"
      animationDuration=".8s"> </p-progressSpinner>
  </div>
</div>

<p-popover class="overly-filter" styleClass="report-overly" #overlyFilter>
  <div class="overly-filter__outer overly-filter__outer--report-filter">
    <h2 class="filter-title">Filters</h2>
    <a href="javascript:void(0);" class="filter-close" (click)="overlyFilter.toggle($event); onClear(null)">
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
        <path d="M18.2116 2.8568L2.78845 18.1432" stroke="#3E3E3E" stroke-width="2.5" />
        <path d="M18.143 18.2116L2.85657 2.78844" stroke="#3E3E3E" stroke-width="2.5" />
      </svg>
    </a>
    <div class="overly-filter__scroll">
      <div class="form__group">
        <label class="form__label">Appt. Date</label>
        <input matInput class="form__control" ngxDaterangepickerMd placeholder="Appt. Date"
          [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [customRangeDirection]="true"
          [(ngModel)]="searchRequest.appointmentDate" [ranges]="dateRanges" [showClearButton]="true" [showCancel]="true"
          [linkedCalendars]="true" [locale]="locale" [keepCalendarOpeningWithRange]="true"
          [showRangeLabelOnInput]="true" />
      </div>

      <div class="form__group">
        <label class="form__label">Transaction Date Range</label>
        <input matInput class="form__control" ngxDaterangepickerMd placeholder="Date" [showCustomRangeLabel]="true"
          [alwaysShowCalendars]="true" [customRangeDirection]="true" [(ngModel)]="searchRequest.transactionDate"
          [ranges]="dateRanges" [showClearButton]="true" [showCancel]="true" [linkedCalendars]="true" [locale]="locale"
          [keepCalendarOpeningWithRange]="true" [showRangeLabelOnInput]="true" />
      </div>

      <div class="form__group">
        <label class="form__label">Transaction Status</label>
        <p-select class="form__dropdown select-box" [(ngModel)]="searchRequest.transactionStatus" [options]="statuses"
          placeholder="Transaction Status"> </p-select>
      </div>

      <div class="form__group">
        <label for="name" class="form__label">Branch</label>
        <p-multiSelect class="form__multiSelect select-box"  [options]="branchOptions" [(ngModel)]="searchRequest.branchIds"
          optionLabel="name" optionValue="value"
          placeholder="Select Branch" selectedItemsLabel="{0} Branch Selected">
        </p-multiSelect>
      </div>

    </div>

    <div class="form__group btn-block">
      <button class="btn btn--primary" (click)="onSearch($event, overlyFilter)"
        style="margin-right: 1.5rem">Search</button>
      <button class="btn btn--secondary" (click)="onClear(null)">Clear</button>
    </div>
  </div>
</p-popover>